module.exports = __webpack_public_path__ + "assets/34a5d83306f64e7f95f1b423b14ade30.png";